<script setup>

    import LwxTableHeading from '@/Components/LwxTableHeading.vue'

</script>

<template>

    <div class="grid-cols-16 bg-zinc-50 py-3 border-b border-b-zinc-300 hidden md:grid">

        <div class="col-span-1"></div>

        <LwxTableHeading class="col-span-5">
            Clients &amp; Caregivers
        </LwxTableHeading>

        <LwxTableHeading class="col-span-3 hidden md:flex">
            Add New Rating
        </LwxTableHeading>

        <LwxTableHeading class="col-span-2">
            Last Rated
        </LwxTableHeading>

        <LwxTableHeading class="col-span-2">
            Schedule
        </LwxTableHeading>

        <LwxTableHeading class="col-span-3 pl-8 hidden md:flex">
            Actions
        </LwxTableHeading>

    </div>

</template>
